<template>
  <div class="solutions">
    <HeaderStyle1>
      <h1 slot="title" v-html="$t('solutions-head-h1')"></h1>
      <p slot="detail" v-html="$t('solutions-head-small')"></p>
      <b-img slot="image" class="head-img" src="../assets/imgs/head-img-solutions.png" alt="" ></b-img>
    </HeaderStyle1>

    <b-container fluid="xl" >
      <b-row><b-col cols="12" md="9"><h2 class="content-title">{{$t('solutions-content-title')}}</h2></b-col></b-row>

      <b-row :gutters="50">
        <b-col v-for="item in list"
               :key="item.title"
               cols="12"
               xl="4"
               md="6"
               sm="12"
               class="mb-5 clearfix"
        >
          <router-link :to="item.to" class="item-wrap">
            <div class="item">
              <div class="img"><b-img :src="item.image" fluid></b-img></div>
              <h5>{{item.title}}</h5>
              <p>{{item.detail}}</p>
            </div>
          </router-link>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import HeaderStyle1 from '../components/HeaderStyles1.vue'

export default {
  name: 'Solutions',
  components: {
    HeaderStyle1
  },
  data () {
    return {
      list: [
        {
          image: require('../assets/imgs/resolution-img-1.png'),
          title: this.$t('solutions-item-1-title'),
          detail: this.$t('solutions-item-1-detail'),
          to: '/construction'
        },
        {
          image: require('../assets/imgs/resolution-img-2.png'),
          title: this.$t('solutions-item-2-title'),
          detail: this.$t('solutions-item-2-detail'),
          to: '/retail'
        },
        {
          image: require('../assets/imgs/resolution-img-3.png'),
          title: this.$t('solutions-item-3-title'),
          detail: this.$t('solutions-item-3-detail'),
          to: '/health-care'
        },
        {
          image: require('../assets/imgs/resolution-img-4.png'),
          title: this.$t('solutions-item-4-title'),
          detail: this.$t('solutions-item-4-detail'),
          to: '/event-venues'
        },
        {
          image: require('../assets/imgs/resolution-img-5.png'),
          title: this.$t('solutions-item-5-title'),
          detail: this.$t('solutions-item-5-detail'),
          to: '/transportation'
        },
        {
          image: require('../assets/imgs/resolution-img-6.png'),
          title: this.$t('solutions-item-6-title'),
          detail: this.$t('solutions-item-6-detail'),
          to: '/hospitality'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  .solutions {
    .head-img {
      max-width: 40% !important;
      bottom: 0 !important;
    }

    .content-title {
      font-size: 34px;
      font-weight: 700;
      color: #000000;
      margin: 86px 0 33px 0;
    }

    .item-wrap {
      text-decoration: none;
    }
    .item {
      box-shadow: 0px 3px 30px 0px rgba(0,0,0,0.16);
      border-bottom: 1px solid transparent;

      .img {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 5;
          background-color: rgba(190, 112, 255, 0.3);
        }
      }
      h5 {
        font-size: 30px;
        font-weight: 700;
        text-align: center;
        color: #000000;
        margin-top: 23px;
      }
      p{
        opacity: 0.8;
        font-size: 15px;
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 20px;
        margin-top: 26px;
        min-height: 40px;
        padding: 0 45px;
      }
    }
  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .content-title {
      font-size: 18px !important;
      text-align: center;
      margin-top: 30px !important;
    }
  }
</style>
